import {
  ACTIVE_PRODUCTS_DISPLAY_NAMES,
  DISPLAY_NAME_TO_LABEL_NAMES,
} from "./deriveActiveProductsFromGeneralInfo";
import type { MetricSimplifiedRow } from "./bulkUpdateCamerasApi";

/**
 * label_name -> active for one camera (GET /metric/simplified/ rows).
 * If the same label appears on multiple rows, prefer active: true (matches general_info merge).
 */
export const getLabelNameActiveMapForCameraFromSimplifiedRows = (
  rows: MetricSimplifiedRow[],
  cameraId: number
): Map<string, boolean> => {
  const map = new Map<string, boolean>();
  rows.forEach((r) => {
    if (Number(r.camera?.id) !== cameraId) {
      return;
    }
    const prev = map.get(r.label_name);
    if (prev === undefined || r.active) {
      map.set(r.label_name, r.active);
    }
  });
  return map;
};

/** Same display-name record shape as `deriveActiveProductsFromGeneralInfo` (bulk Current Products table). */
export const activeProductsDisplayRecordFromSimplifiedRows = (
  rows: MetricSimplifiedRow[],
  cameraId: number
): Record<string, boolean> => {
  const labelMap = getLabelNameActiveMapForCameraFromSimplifiedRows(rows, cameraId);
  const result: Record<string, boolean> = {};
  ACTIVE_PRODUCTS_DISPLAY_NAMES.forEach((displayName) => {
    const candidates = DISPLAY_NAME_TO_LABEL_NAMES[displayName] || [];
    result[displayName] = candidates.some((ln) => labelMap.get(ln) === true);
  });
  return result;
};
